"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var components_1 = require("./components");
var services_1 = require("./services");
exports.appRoutes = [
    {
        path: ':lang/game',
        redirectTo: ':lang/game/packs',
        pathMatch: 'full'
    },
    {
        path: 'game',
        component: components_1.MainComponent,
        canActivate: [services_1.ShortPathGameGuardService]
    },
    {
        path: ':lang/game/packs',
        component: components_1.MainComponent,
        children: [
            {
                path: '',
                component: components_1.PacksBoxComponent
            },
            {
                path: ':packId',
                component: components_1.LevelsBoxComponent,
                canActivate: [services_1.LevelBoxGuardService]
            }
        ]
    },
    {
        path: 'game/packs',
        component: components_1.MainComponent,
        children: [
            {
                path: '',
                component: components_1.PacksBoxComponent,
                canActivate: [services_1.ShortPathGameGuardService]
            },
            {
                path: ':packId',
                component: components_1.LevelsBoxComponent,
                canActivate: [services_1.ShortPathGameGuardService]
            }
        ]
    },
    {
        path: 'game/:levelId',
        component: components_1.MainComponent,
        canActivate: [services_1.ShortPathGameGuardService]
    },
    {
        path: ':lang/game/packs/:packId/level/:levelId',
        component: components_1.LevelComponent,
        canActivate: [services_1.LevelGuardService]
    },
    {
        path: 'game/packs/:packId/level/:levelId',
        component: components_1.LevelComponent,
        canActivate: [services_1.ShortPathGameGuardService]
    },
    {
        path: ':lang/game/:levelId',
        component: components_1.LevelComponent,
        canActivate: [services_1.LevelGuardService]
    },
    {
        path: '**',
        redirectTo: 'game/notfound'
    }
];



//////////////////
// WEBPACK FOOTER
// ./src/index.router.ts
// module id = 255
// module chunks = 0